import React 			from 'react';
import PropTypes 	from 'prop-types';


// this.props.classes				: string of classes
// this.props.isChecked 		: boolean
// this.props.onChangeFunc 	: function to handle change
// this.props.id 						: string of id for labels
// this.props.value 				: string of value

export default class CustomRadio extends React.PureComponent {
	constructor(props) {
		super(props);
	}

	render() {
		const {classes = '', id = '', value = '', isDisabled, checkIcon = false} = this.props;
		
		return (
			<label className={"custom-radio " + classes + (isDisabled ? ' custom-radio--disabled' : '') + (checkIcon ? ' custom-radio--check-icon' : '')}>
				<input id={id} type="radio" className="custom-radio__radio" value={value} disabled={isDisabled} checked={this.props.isChecked} onChange={(e) => this.props.onChangeFunc(e)}/>
				<span className={"custom-radio__new-radio" + (isDisabled ? ' custom-radio__new-radio--disabled' : '')}></span>
			</label>
		);
	}
}

CustomRadio.propTypes = {
		classes: PropTypes.string
	,	isChecked: PropTypes.bool.isRequired
	,	isDisabled: PropTypes.bool
	, onChangeFunc: PropTypes.func.isRequired
	,	id: PropTypes.string
	,	value: PropTypes.any
}